import { render } from "./ListRecipesComponent.vue?vue&type=template&id=756eb29b&scoped=true"
import script from "./ListRecipesComponent.vue?vue&type=script&lang=js"
export * from "./ListRecipesComponent.vue?vue&type=script&lang=js"

import "./ListRecipesComponent.vue?vue&type=style&index=0&id=756eb29b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756eb29b"]])

export default __exports__